import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Loader2, ShieldAlert } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const [email, setEmail] = useState("alex@gruposoeasy.com.br");
  const [password, setPassword] = useState("Alex@2026");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bem-vindo à SOEASY");
      navigate("/setores");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Credenciais inválidas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-stretch bg-[#0A0B1A] relative overflow-hidden">
      {/* Ambient glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[-20%] right-[-10%] w-[600px] h-[600px] rounded-full bg-[#B28F4B]/10 blur-[120px]" />
        <div className="absolute bottom-[-20%] left-[-10%] w-[500px] h-[500px] rounded-full bg-[#1A1D42] blur-[100px]" />
      </div>

      {/* Panel esquerdo - identidade */}
      <div className="hidden md:flex flex-1 relative z-10 flex-col justify-between p-14">
        <Logo size="lg" />

        <div className="max-w-md">
          <div className="text-[#B28F4B] text-[11px] font-bold tracking-[0.3em] uppercase mb-6">
            Plataforma Enterprise · v1.0
          </div>
          <h1 className="font-heading text-5xl xl:text-6xl font-light text-white leading-[1.05] mb-8">
            Governança,<br />
            <span className="text-[#B28F4B] font-medium">Compliance</span> e<br />
            documentação<br />
            em <em className="font-serif italic">um só lugar.</em>
          </h1>
          <p className="text-[#A1A4C7] text-base leading-relaxed max-w-sm">
            Sistema unificado SOEASY Security para gestão de processos disciplinares (PAI, Sindicância, PDI),
            documentos institucionais e orçamentos com CCT — assistido por inteligência artificial.
          </p>
        </div>

        <div className="text-[#6B6E8F] text-xs font-mono">
          © 2026 SOEASY Security · Todos os direitos reservados
        </div>
      </div>

      {/* Formulário */}
      <div className="flex-1 relative z-10 flex items-center justify-center p-6 md:p-14 md:border-l md:border-[#B28F4B]/15">
        <div className="w-full max-w-md">
          <div className="md:hidden mb-10 flex justify-center">
            <Logo />
          </div>

          <div className="soeasy-card p-8 md:p-10 fade-up">
            <div className="mb-8">
              <div className="text-[#B28F4B] text-[10px] font-bold tracking-[0.3em] uppercase mb-3">
                Acesso restrito
              </div>
              <h2 className="font-heading text-3xl font-medium text-white mb-2">Entrar</h2>
              <p className="text-[#A1A4C7] text-sm">Digite suas credenciais corporativas para continuar.</p>
            </div>

            <form onSubmit={submit} className="space-y-5">
              <div>
                <label className="text-[10px] font-bold uppercase tracking-widest text-[#B28F4B] block mb-2">E-mail</label>
                <input
                  data-testid="login-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                  className="w-full bg-[#0A0B1A] border border-[#B28F4B]/20 focus:border-[#B28F4B] rounded-lg px-4 py-3 text-white outline-none focus:ring-2 focus:ring-[#B28F4B]/30 transition"
                  placeholder="voce@soeasy.com.br"
                />
              </div>
              <div>
                <label className="text-[10px] font-bold uppercase tracking-widest text-[#B28F4B] block mb-2">Senha</label>
                <input
                  data-testid="login-password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                  className="w-full bg-[#0A0B1A] border border-[#B28F4B]/20 focus:border-[#B28F4B] rounded-lg px-4 py-3 text-white outline-none focus:ring-2 focus:ring-[#B28F4B]/30 transition"
                  placeholder="••••••••"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                data-testid="login-submit"
                className="w-full bg-[#B28F4B] hover:bg-[#D4AF37] text-[#1A1D42] font-bold py-3.5 rounded-lg transition-all flex items-center justify-center gap-2 disabled:opacity-60"
              >
                {loading ? <Loader2 size={18} className="animate-spin" /> : "Entrar"}
              </button>
            </form>

            <div className="mt-6 pt-6 border-t border-[#B28F4B]/10">
              <div className="text-[10px] uppercase tracking-widest text-[#6B6E8F] font-bold mb-2">Credenciais demonstração</div>
              <div className="grid grid-cols-2 gap-1.5 text-[11px] font-mono">
                <div className="text-[#A1A4C7]">alex@gruposoeasy.com.br</div><div className="text-[#B28F4B]">Alex@2026</div>
                <div className="text-[#A1A4C7]">diretor@soeasy.com.br</div><div className="text-[#B28F4B]">Soeasy@2026</div>
                <div className="text-[#A1A4C7]">compliance@soeasy.com.br</div><div className="text-[#B28F4B]">Soeasy@2026</div>
              </div>
            </div>
          </div>

          <div className="mt-6 text-center space-y-2">
            <Link
              to="/canal-denuncia"
              data-testid="link-canal-denuncia"
              className="inline-flex items-center gap-2 text-[#B28F4B]/80 hover:text-[#B28F4B] text-sm font-medium transition"
            >
              <ShieldAlert size={16} />
              Canal de denúncias público (sem login)
            </Link>
            <div>
              <Link
                to="/documentacao"
                data-testid="link-documentacao"
                className="inline-flex items-center gap-2 text-[#A1A4C7] hover:text-white text-xs font-medium transition"
              >
                📄 Documentação e Manual do Colaborador
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
